<template>
  <van-popup
    round
    overlay-class="score-container"
    style="margin-top:-20px;"
    v-model="active"
    @close="onClose"
  >
    <div class="score-content" @click="closeAndReturn">
      <div class="score-desc">本次作业您获得</div>
      <div class="score-number">{{score}}</div>
      <div class="score-grade">学分</div>
      <div class="stars">
        <div class="star-1 star"></div>
        <div class="star-2 star"></div>
        <div class="star-3 star"></div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'score',
  props: {
    isScoreActive: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {
        wx.miniProgram.navigateBack()
      }
    },
    score: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      active: true
    }
  },
  mounted() {},
  methods: {
    closeAndReturn() {
      this.props.onClose()
    }
  }
}
</script>

<style scoped lang="scss">
.star {
  position: absolute;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.star-1 {
  width: halvePx(24);
  height: halvePx(24);
  left: halvePx(166);
  top: halvePx(157);
  background-image: url('../assets/imgs/scoreResult/star1.png');
}

.star-2 {
  width: halvePx(23);
  height: halvePx(23);
  right: halvePx(175);
  top: halvePx(224);
  background-image: url('../assets/imgs/scoreResult/star2.png');
}

.star-3 {
  width: halvePx(17);
  height: halvePx(17);
  left: halvePx(181);
  top: halvePx(257);
  background-image: url('../assets/imgs/scoreResult/star2.png');
}

.score-content {
  position: relative;
  background: rgba(251, 244, 226, 1);
  border-radius: 10px;
}

.score-content {
  width: halvePx(640);
  height: halvePx(400);
  font-size: halvePx(32);
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: halvePx(48);
  padding-top: halvePx(50);
  text-align: center;
}

.score-grade {
  margin-top: halvePx(24);
}

.score-number {
  width: halvePx(128);
  height: halvePx(128);
  margin: halvePx(42) auto 0 auto;
  line-height: halvePx(128);
  text-align: center;
  font-size: halvePx(48);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 50%;
  background: url('../assets/imgs/scoreResult/result-bg.png') no-repeat center/100%, #ffffff;
}
</style>
